import { subscribeToTopic, unsubscribeFromTopic } from '../Api/api';
import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

const VAPID_KEY = "BGq-35HelHwHHSEMFFYF8UToT5mhoKvE-H84lkQqcgJE3EsUSaosgJ1PjcuQJHPFMWi5syqPvpZHlUtklnfqPM8";

export const firebaseConfig = {
  apiKey: "AIzaSyDlYBkQ6TPh_giUYOB6NMl87Eq6pnNqsMQ",
  authDomain: "push-notification-83941.firebaseapp.com",
  projectId: "push-notification-83941",
  storageBucket: "push-notification-83941.firebasestorage.app",
  messagingSenderId: "432299854227",
  appId: "1:432299854227:web:26a6835316f4787e9a0066",
  measurementId: "G-20M0DPLJMF"
};

 const app = initializeApp(firebaseConfig);
 const messaging = getMessaging(app);

export const requestNotificationPermission = async () => {
  const permission = await Notification.requestPermission();
  if (permission === 'granted') {
    try {
      const registrstion = await navigator.serviceWorker.register('/firebase-messaging-sw.js');
      const token = await getToken(messaging, { vapidKey: VAPID_KEY, serviceWorkerRegistration: registrstion });
      console.log(token);
      return token;
    } catch (error) {
      console.error("Error registering service worker:", error);
      return null;
    }
  } else {
    console.warn("Notification permission denied.");
    return null;
  }
};

export const subscribeTopics = async (topics) => {
  const token = await requestNotificationPermission();
  if (!token || !Array.isArray(topics) || topics.length === 0) return;

  for (const topic of topics) {
    try {
      const res = await subscribeToTopic(token, topic);
      console.log(res, "subscribed to topic", topic);
    } catch (err) {
      console.error(`Failed to subscribe to ${topic}`, err);
    }
  }
};

export const subscribeUserToTopics = async (user) => {
  if (!user) {
    return subscribeTopics(['All']);
  }

  const topics = [];
  if (user?.Region?.Description) {
    const region = user.Region.Description.replace(/ /g, '_');
    topics.push(region);
  }
  if (user?.Segments && user?.Segments?.length > 0) {
    user?.Segments.forEach((segment) => {
      if (segment?.Description) {
        const segmentName = segment.Description.replace(/ /g, '_');
        topics.push(segmentName);
      }
    })
  }
  if (user?._id) topics.push(user._id);
  if (user?.Profiles[0]?.Language) {
    const language = user?.Profiles[0]?.Language?.Description.replace(/ /g, '_');
    topics.push(language);
  }

  await subscribeTopics(topics);
};


export const unsubscribeTopics = async (topics) => {
  const token = await requestNotificationPermission();
  if (!token || !Array.isArray(topics) || topics.length === 0) return;

  for (const topic of topics) {
    try {
      const res = await unsubscribeFromTopic(token, topic.replace(/ /g, '_'));
      console.log(res, "unsubscribed from topic", topic);
    } catch (err) {
      console.error(`Failed to unsubscribe from ${topic}`, err);
    }
  }
};

export const handleForegroundMessages = () => {
  onMessage(messaging, (payload) => {
    const { title, body, image } = payload?.notification || {};

    if (Notification.permission === 'granted' && title && body) {
      new Notification(title, {
        body,
        icon: image || '/icon.png',
      });
    }
  });
};
